import React from 'react';
import { View, Text, ActivityIndicator } from 'react-native';
import { Button, Input } from 'react-native-elements';
import Modal from 'modal-enhanced-react-native-web';

const { USDT, TOKEN, TOKEN_NAME } = require('../Data');
const { tokenToCoin, getFloorPrice, getGrowth, sell, getAllowanceSell, approveSell, openExplorerTx, publishWalletData } = require('../BlockLib');

class PanelReward extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: 'busy',
      modalVisible: false,
      floorPrice: 0,
      sellAmount: null,
      coinReceived: 0,
      allowSell: 0,
      pctg: 0
    };
  }

  async componentDidMount() {
    const floorPrice = await getFloorPrice();
    const { age, pctg, pctgDaily, pctgYearly } = await getGrowth();
    this.setState({ floorPrice, show: 'form', age, pctg, pctgDaily, pctgYearly });
    this.refreshAllowance();

    this.interval = setInterval(async () => {
      const floorPrice = await getFloorPrice();
      const { age, pctg, pctgDaily, pctgYearly } = await getGrowth();
      this.setState({ floorPrice, age, pctg, pctgDaily, pctgYearly });
    }, 5000);

  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  async setSellAmount(value) {
    const amount = value;
    this.setState({ sellAmount: amount });
    const coinReceived = await tokenToCoin(amount);
    this.setState({ coinReceived });
  }

  async refreshAllowance() {
    const allowSell = await getAllowanceSell();
    this.setState({ allowSell });
  }

  async handleApprove() {
    try {
      const sellAmount = this.state.sellAmount;
      this.setState({ modalVisible: true, txHash: false });
      const txHash = await approveSell(sellAmount);
      this.refreshAllowance();
      this.setState({ txHash });
    } catch (err) {
      if (err && err.message) showToast(err.message);
    }
  }

  async handleSell() {
    const sellAmount = this.state.sellAmount;
    this.setState({ modalVisible: true, txHash: false });
    const txHash = await sell(sellAmount);
    this.refreshAllowance();
    await publishWalletData();
    this.setState({ txHash });
  }

  renderBusy() {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <ActivityIndicator />
      </View>
    );
  }

  renderModal() {
    let indicator = <ActivityIndicator />;
    let msg = 'PROCESS TX';
    if (this.state.txHash) {
      msg = 'PROCESS TX DONE';
      const txHash = this.state.txHash;
      indicator = <Button type="outline" title='OPEN ON EXPLORER' onPress={() => openExplorerTx(txHash)} />
    }

    return (
      <Modal
        isVisible={this.state.modalVisible}
        onBackdropPress={() => this.setState({ modalVisible: false })}
      >
        <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ backgroundColor: 'white', padding: 20 }}>
            <Text> </Text>
            <Text style={{ textAlign: 'center' }}>{msg}</Text>
            <Text> </Text>
            <View>
              {indicator}
              <Text> </Text>
              <Button type="outline" title='CLOSE' onPress={() => this.setState({ modalVisible: false })} />
            </View>
            <Text> </Text>
          </View>
        </View>
      </Modal>
    );
  }

  render() {
    let approveDisabled = false;
    if (Number(this.state.allowSell) >= Number(this.state.sellAmount)) {
      approveDisabled = true;
    }

    let sellDisabled = !approveDisabled;

    if (this.state.sellAmount > 0) {
    } else {
      sellDisabled = true;
    }

    const ageDays = Math.floor((this.state.age / (3600 * 24)) * 100) / 100;
    return (
      <View style={{ padding: 10, backgroundColor: '#eee' }}>
        {this.renderModal()}
        <Text style={{ textAlign: 'center', fontWeight: 'bold' }}>BUYBACK PRICE DATA</Text>
        <Text> </Text>
        <Text style={{ textAlign: 'center' }}>CONTRACT AGE {ageDays} DAYS</Text>
        <Text style={{ textAlign: 'center' }}>PRICE INCREASE {this.state.pctg} %</Text>
        <Text style={{ textAlign: 'center' }}>AVERAGE DAILY INCREASE {this.state.pctgDaily} %</Text>
        <Text style={{ textAlign: 'center' }}>PROJECTED ANNUAL INCREASE {this.state.pctgYearly} %</Text>
        <Text style={{ textAlign: 'center' }}> </Text>
        <Text style={{ textAlign: 'center' }}>{TOKEN_NAME.toUpperCase()} BUYBACK PRICE</Text>
        <Text style={{ textAlign: 'center' }}>1 {TOKEN} = {this.state.floorPrice} {USDT}</Text>
        <Text style={{ textAlign: 'center' }}> </Text>
        <Input
          placeholder={'ENTER ' + TOKEN + ' AMOUNT'}
          onChangeText={value => this.setSellAmount(value)}
          value={this.state.sellAmount}
          keyboardType='numeric'
        />
        <Text style={{ textAlign: 'center' }}>SWAP FOR {this.state.coinReceived} {USDT}</Text>
        <Text style={{ textAlign: 'center' }}></Text>
        <Text> </Text>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}><Button disabled={approveDisabled} title="APPROVE" onPress={() => this.handleApprove()} /></View>
          <View style={{ width: 10 }} />
          <View style={{ flex: 1 }}><Button disabled={sellDisabled} title="SWAP" onPress={() => this.handleSell()} /></View>
        </View>
        <Text> </Text>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}><Button type="outline" title="BACK" onPress={() => this.props.handleHome()} /></View>
        </View>
      </View>
    );
  }

}

export default PanelReward;
